<template>
  <div>
    <TitleBar>
      <template v-slot:title><translate>Hours</translate></template>
      <template v-slot:buttons>
        <!-- <OnboardingIntroLink :onboarding-intro="'onboarding_web_hours'" /> -->
        <GekkoButton 
          v-if="selectedProject"
          :href="invoiceHours" 
          :text="$gettext('Invoice Hours')" 
          icon="fa-solid fa-plus"
          class="mr-2"
        />
        <GekkoButton 
          @click="startTimer" 
          :text="$gettext('Start timer')" 
          icon="fa-solid fa-plus"
          variant="outline-primary"
          class="mr-2"
        />
        <GekkoButton 
          :to="{name: 'HoursReport'}" 
          :text="$gettext('Hours report')" 
          icon="fa-solid fa-chart-simple"
          variant="outline-primary"
        />
      </template>
    </TitleBar>
    <div class="content content--hours">
      <HoursTable @selected-project="setSelProject" :refresh-hours="refreshHours" />
    </div>
  </div>
</template>
<script>
import TitleBar from "@/components/TitleBar";
import HoursTable from "@/components/hours/HoursTable";
import GekkoButton from "@/components/GekkoButton";
// import OnboardingIntroLink from "@/components/ui/OnboardingIntroLink"

export default {
  name: "Hours",
  components: {
    TitleBar, HoursTable, GekkoButton, //OnboardingIntroLink
  },
  props: {
    refreshHours: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      selectedProject: false
    }
  },
  computed: {
    invoiceHours () {
      // Invoices link -> /invoices/add/<company_id>/<project_id>/#/hours/
      let link
      (this.selectedProject && this.selectedProject.company)
        ? link = '/invoices/create/' + this.selectedProject.company + ((this.selectedProject.id) ? '/' + this.selectedProject.id : '') + '/?import=hours'
        : link = '#'
      return link
    },
    hoursReport (){
      // Hours report link -> /hours/report/#/report/?customer=<company_id>&project=<project_id>
      let link
      // const base = '/hours/v1/#/report/?'
      const base = '/reports/page/#/hours/?';
      if (this.selectedProject && (this.selectedProject.company||this.selectedProject.id)) {
        let params = []
        if (this.selectedProject.company) {
          params.push('customer=' + this.selectedProject.company)
        }
        if (this.selectedProject.id) {
          params.push('project=' + this.selectedProject.id)
        }
        link = base + params.join('&')
      } else {
        link = base
      }
      return link
    }
  },
  methods: {
    setSelProject (value) {
      this.selectedProject = value
    },
    startTimer () {
      this.$emit('startTimer', false)
    }
  }
}
</script>
<style scoped lang="scss">
.content {
  &--hours {
    display: flex;
    flex-direction: column;
    flex: 1;
  }
}
</style>
